import PropTypes from 'prop-types'

const Logomark = ({ style, fill, size = 20, withText = false }) => {
  if (withText) {
    return (
      <img
        src="/cid-logo.svg"
        alt="Polis — Center for Innovations Development"
        height={size}
        style={{ display: 'block', ...style }}
      />
    )
  }

  return (
    <svg
      width={size}
      viewBox="0 0 88 100"
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M44 0L87.3013 25V75L44 100L0.69873 75V25L44 0Z" fill={fill} />
    </svg>
  )
}

Logomark.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  size: PropTypes.number,
  withText: PropTypes.bool
}

export default Logomark
